import About from "./About.jsx";
export default About;
